import React from 'react';
import { Switch } from '@mui/material';
import { CronJobSwitchProps } from 'src/components/Cron/CronJobSwitch.types';

export const CronJobSwitch: React.FC<CronJobSwitchProps> = ({ isActivated, onToggle }) => {
  return <Switch checked={isActivated} onClick={onToggle} />;
};
